import { apidocsFromElasticConstants } from '../constants'

const initialState = {}

export default (state = initialState, action = {}) => {
    const { slug } = action
    switch (action.type) {
        case apidocsFromElasticConstants.REQUEST:
            return {
                ...state,
                [slug]: {
                    ...(state[slug] || {}),
                    pending: true,
                },
            }
        case apidocsFromElasticConstants.SUCCESS:
            return {
                ...state,
                [slug]: {
                    results: action.response.data.results,
                    pending: false,
                },
            }
        case apidocsFromElasticConstants.FAILURE:
            return {
                ...state,
                [slug]: {
                    error: action.error,
                    pending: false,
                },
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/apidocsFromElastic.js